import { render, staticRenderFns } from "./CompleteApproval.vue?vue&type=template&id=6ab87940&"
import script from "./CompleteApproval.vue?vue&type=script&lang=js&"
export * from "./CompleteApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports